import styles from "./SearchBar.module.css"
import { SetStateAction, useState } from "react"
import { useStorePlayers } from "../store"
interface Props {
  quickSearch: string | any
}

export function SearchBar(props: Props) {
  const { statePlayers } = useStorePlayers()
  const [inputValue, setInputValue] = useState(statePlayers.currentQuickSearch ?? "")

  const onChangeHandler = (event: { target: { value: SetStateAction<string> } }) => {
    props.quickSearch(event.target.value)
    setInputValue(event.target.value)
  }
  return (
    <div className={styles.wrap}>
      <div className={styles.search}>
        <button type="submit" className={styles.searchButton}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
          </svg>
        </button>
        <input type="text" className={styles.searchTerm} onChange={onChangeHandler} value={inputValue} id="input_text" />
      </div>
    </div>
  )
}
